import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { EvaluationReport } from "@/schema/console/evaluation-reports/EvaluationReport";
import EvaluationRow from "@/src/console/(auth)/_components/EvaluationReport/SdgIndicatorCard/EvaluationRow";
import {
  ChevronDown20Regular as ChevronDown,
  ChevronUp20Regular as ChevronUp,
  TargetArrow20Regular,
} from "@fluentui/react-icons";
import { useState } from "react";
import { useController, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CollapsibleGoalProps {
  index: number;
}

function CollapsibleGoal({ index }: CollapsibleGoalProps) {
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();
  const { control } = useFormContext<EvaluationReport>();

  const {
    field: {
      value: { sdg_goal_id, name, sdg_target_results },
    },
  } = useController({
    control,
    name: `result_index.sdg_goal_results.${index}`,
  });

  const { fields } = useFieldArray({
    control,
    name: `result_index.sdg_goal_results.${index}.sdg_target_results`,
    keyName: "key",
  });

  const CollapseIndicatorArrow = isOpen ? (
    <ChevronUp color="#6B7280" />
  ) : (
    <ChevronDown color="#6B7280" />
  );
  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <div className=" flex flex-row items-center justify-between bg-cool-gray-100 hover:bg-cool-gray-200 transition-colors duration-300 py-2 px-3 cursor-pointer border-t border-cool-gray-200">
          <div className=" flex flex-row space-x-3 items-center">
            <TargetArrow20Regular />
            <p className=" text-sm font-medium text-cool-gray-900">
              {t("goal")} {sdg_goal_id}: {name}
            </p>
          </div>
          <div className=" flex flex-row space-x-4 items-center">
            <p className=" text-xs font-medium text-cool-gray-500">
              {sdg_target_results.length} {t("targets")}
            </p>
            {CollapseIndicatorArrow}
          </div>
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>
        {fields.map((field, targetIndex) => (
          <EvaluationRow
            key={field.key}
            goalId={sdg_goal_id}
            goalIndex={index}
            targetIndex={targetIndex}
          />
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
}

export default CollapsibleGoal;
